import React, { useEffect, useState, useContext } from "react";
import { connect } from "react-redux";
import "./index.css";
import ContextForm from "../../ReportForm/contextForm";
import check from "../../../../../assets/images/check-mark.png";

const CheckButton = (props) => {
  const { label, options, isRequired, onChange } = props;
  const context = useContext(ContextForm);
  const { errorFieldsPublicForm, errorFieldsProfessionalForm } = context;
  const [checkData, setCheckData] = useState(options);
  const [errorField, setErrorField] = useState(false);

  const handleChange = (index, item) => {
    const newData = checkData.map((currentItem) => {
      if (currentItem.id === item.id) {
        return {
          ...item,
          isChecked: !item.isChecked,
        };
      } else {
        return currentItem;
      }
    });
    let checked = newData.filter(d => {
      if (typeof d.isChecked === 'string') return d.isChecked !== 'false'
      return d.isChecked
    }).length
    if (
      !checked &&
      isRequired &&
      (errorFieldsPublicForm === true || errorFieldsProfessionalForm === true)
    ) {
      setErrorField(true);
    } else {
      setErrorField(false)
    }

    setCheckData(newData);
    onChange(newData);
  };

  useEffect(() => {
    let checked = checkData.filter(d => {
      if (typeof d.isChecked === 'string') return d.isChecked !== 'false'
      return d.isChecked
    }).length
    if (
      !checked &&
      isRequired &&
      (errorFieldsPublicForm === true || errorFieldsProfessionalForm === true)
    ) {
      setErrorField(true);
    } else {
      setErrorField(false)
    }
    return () => { };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorFieldsPublicForm, errorFieldsProfessionalForm]);

  console.log('errorField', errorField)

  return (
    <div className="element" style={{ justifyContent: "space-between" }}>
      <label className="label">
        {label}
        {isRequired && <span>*</span>}
      </label>
      <div className={`container-pair-check-button ${errorField ? "error_form" : ""
        }`}>
        {checkData &&
          Array.isArray(checkData) === true &&
          checkData.map((item, index) => {
            return (
              <div className="pair-check-button">
                <div
                  className={`${"check"}`}
                  onClick={() => {
                    handleChange(index, item);
                  }}
                >
                  {item.isChecked === true && <img src={check} alt="check" />}
                </div>
                <label className="label-check" for={item.label}>
                  {item.label}
                </label>
              </div>
            );
          })}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  settings: state.settings,
});

export default connect(mapStateToProps)(CheckButton);
